import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import PatientSelectionPage from './pages/PatientSelectionPage';
import PatientChartPage from './pages/PatientChartPage';
import ConversationPage from './pages/ConversationPage';
import InterventionPage from './pages/InterventionPage';
import EvaluationPage from './pages/EvaluationPage';
import SessionReviewPage from './pages/SessionReviewPage';
import FeedbackReceivePage from './pages/FeedbackReceivePage';
import FeedbackProvidePage from './pages/FeedbackProvidePage';
import PatientFeedbackPage from './pages/PatientFeedbackPage';
import PatientFeedbackViewPage from './pages/PatientFeedbackViewPage';
import AdminDashboard from './pages/AdminDashboard';
import ConsentPage from './pages/ConsentPage';
import SurveyPage from './pages/SurveyPage';
import HistoryPage from './pages/HistoryPage';
import GroupCSelectionPage from './pages/GroupCSelectionPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<LoginPage />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/consent" element={<ConsentPage />} />
            <Route path="/survey" element={<SurveyPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/group-c-selection" element={<GroupCSelectionPage />} />
            {/* PatientSelectionPage removed for linear flow */}
            <Route path="/patient-chart/:patientId" element={<PatientChartPage />} />
            <Route path="/conversation/:patientId" element={<ConversationPage />} />
            <Route path="/intervention/:patientId" element={<InterventionPage />} />
            <Route path="/evaluation/:sessionId" element={<EvaluationPage />} />
            <Route path="/session/:sessionId" element={<SessionReviewPage />} />
            <Route path="/feedback/receive/:sessionId" element={<FeedbackReceivePage />} />
            <Route path="/feedback/provide/:sessionId" element={<FeedbackProvidePage />} />
            <Route path="/patient-feedback/:sessionId" element={<PatientFeedbackPage />} />
            <Route path="/patient-feedback-view/:sessionId" element={<PatientFeedbackViewPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>

          <Route path="/" element={<Navigate to="/patient-chart/patient_0" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
